import type { Layout } from "react-grid-layout"

import {
  deviceTabLayoutLg,
  spanTabLayoutLg,
  deviceTowerTabLayoutLg,
  powerlineInfoTabLayoutLg,
  spanOverviewTabLayoutLg,
  towerInfoTabLayoutLg,
  towerTabLayoutLg,
  towerSegmentsTabLayoutLg,
  towerDevicesPlotsLayoutLg,
  towerAmbientTabLayoutLg,
  wServiceAmbientTabLayoutLg,
  wStationAmbientTabLayoutLg,
} from "helpers/config/dashboards"

export const getLayout = (type: string) => {
  switch (type) {
    case "spanTab":
      return spanTabLayoutLg
    case "deviceTab":
      return deviceTabLayoutLg
    case "powerlineInfoTab":
      return powerlineInfoTabLayoutLg
    case "spanOverviewTab":
      return spanOverviewTabLayoutLg
    case "legacyTowerInfoTab":
      return towerInfoTabLayoutLg
    case "towerTab":
      return towerTabLayoutLg
    case "deviceTowerTab":
      return deviceTowerTabLayoutLg
    case "towerSegmentsTab":
      return towerSegmentsTabLayoutLg
    case "towerDevicesPlots":
      return towerDevicesPlotsLayoutLg
    case "towerAmbientTab":
      return towerAmbientTabLayoutLg
    case "wStationAmbientTab":
      return wStationAmbientTabLayoutLg
    case "wServiceAmbientTab":
      return wServiceAmbientTabLayoutLg
    default:
      return {}
  }
}

export const getCellHeight = (name: string, dashboardType: string) => {
  if (dashboardType === "spanTab" && spanTabLayoutLg[name]) {
    return spanTabLayoutLg[name].h
  } else if (dashboardType === "deviceTab" && deviceTabLayoutLg[name]) {
    return deviceTabLayoutLg[name].h
  } else if (dashboardType === "powerlineInfoTab" && powerlineInfoTabLayoutLg[name]) {
    return powerlineInfoTabLayoutLg[name].h
  } else if (dashboardType === "spanOverviewTab" && spanOverviewTabLayoutLg[name]) {
    return spanOverviewTabLayoutLg[name].h
  } else if (dashboardType === "legacyTowerInfoTab" && towerInfoTabLayoutLg[name]) {
    return towerInfoTabLayoutLg[name].h
  } else if (dashboardType === "towerTab" && towerTabLayoutLg[name]) {
    return towerTabLayoutLg[name].h
  } else if (dashboardType === "deviceTowerTab" && deviceTowerTabLayoutLg[name]) {
    return deviceTowerTabLayoutLg[name].h
  } else if (dashboardType === "towerSegmentsTab" && towerSegmentsTabLayoutLg[name]) {
    return towerSegmentsTabLayoutLg[name].h
  } else if (dashboardType === "towerDevicesPlots" && towerDevicesPlotsLayoutLg[name]) {
    return towerDevicesPlotsLayoutLg[name].h
  } else if (dashboardType === "towerAmbientTab" && towerAmbientTabLayoutLg[name]) {
    return towerAmbientTabLayoutLg[name].h
  } else if (dashboardType === "wStationAmbientTab" && wStationAmbientTabLayoutLg[name]) {
    return wStationAmbientTabLayoutLg[name].h
  } else if (dashboardType === "wServiceAmbientTab" && wServiceAmbientTabLayoutLg[name]) {
    return wServiceAmbientTabLayoutLg[name].h
  } else {
    return 0
  }
}

/**
 * The plots in the order they are shown, top to bottom. A chart and its stat
 * card share a `y` and differ by column, so the order needs both. Ordering the
 * children is visually a no-op — react-grid-layout positions every cell by key
 * against the `layouts` prop — but React flushes the effects in mount order, so
 * this is what makes the requests leave in the order the user reads the page.
 */
export const sortPlotDefsByLayout = <T extends { view: { nameKey: string } }>(
  plotDefs: T[],
  layout: Record<string, Layout>,
): T[] =>
  [...plotDefs].sort((a, b) => {
    const cellA = layout[a.view.nameKey]
    const cellB = layout[b.view.nameKey]
    // A def the layout says nothing about keeps its place, at the end.
    if (!cellA) return cellB ? 1 : 0
    if (!cellB) return -1
    return cellA.y - cellB.y || cellA.x - cellB.x
  })
